import React, { Children, useContext, useEffect, useState } from "react";
import Admin from "./layouts/Admin";
import Login from "./pages/Login";
import MunicipalityDataContext from "./helpers/MunicipalityDataContext";
import municipalitiesData from "./data/municipalitiesData.json";
import { Route, Routes } from "react-router-dom";
import MyTest from "./pages/MyTest";
import Test2 from "./pages/Test2";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // اضافه کردن استایل Toastify

function App() {
  const [municipalityInfo, setMunicipalityInfo] = useState(null);

  useEffect(() => {
    //Get the hostname from window.location
    const hostname = window.location.hostname;

    async function fetchMunicipalityData() {
      //Determine witch municipality data to use based on hostname
      const data = municipalitiesData[hostname]; //data for determine witch municipality data to use based on hostname
      setMunicipalityInfo(data);
    }
    fetchMunicipalityData();


    switch (hostname) {
      case "myamol.ir":
        document.title = "آمل من";
        break;
      case "myroyan.ir":
        document.title = "رویان من";
        break;
      case "my.mahmoodabad.ir":
        document.title = "محمودآباد من";
        break;
      default:
        break;
    }
  }, []);

  return (
    <div>
      <MunicipalityDataContext.Provider value={municipalityInfo}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/mytest" element={<MyTest />} />
          <Route path="/test2" element={<Test2 />} />
          <Route path="/*" element={<Admin />} />
        </Routes>
           <div className="rgc-toast">
             <ToastContainer
               autoClose={3000}
              />
             </div>
      </MunicipalityDataContext.Provider>
    </div>
  );
}

export default App;
